import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { filesAPIService } from '~/api/files';
import PDF_DEFAULT_0 from '~/assets/icons/DEFAULT_PDF_0.png';
import DEFAULT_PDF_LOGO from '~/assets/icons/DEFAULT_PDF_LOGO.png';
import { modelMicrositeService } from '~/components/organisms/previewBar/model-data';
import { QR_CODE_BUILDER_CREATED_ID_PARAM_NAME } from '~/constants/qr-code';
import { useAppDispatch } from '~/hooks/useRedux';
import { pdfSlice, updatePdfThunk } from '~/store/reducers/previewScreens/pdf';
import { getPdfReducer } from '~/store/reducers/previewScreens/pdf/selectors';
import { getQrCodeReducerData } from '~/store/reducers/qr-code/selectors';
import { getFileFromLocalSource } from '~/utils/common';
import { logger } from '~/utils/logger';

import PreviewFullPdfViewer from '../../../pdfViewer/preview-full-pdf-viewer/PreviewFullPdfViewer';

import { PDF_TEMPLATE_0 } from './components/PDF_TEMPLATE_0';
import { PDF_TEMPLATE_1 } from './components/PDF_TEMPLATE_1';
import { PDF_TEMPLATE_2 } from './components/PDF_TEMPLATE_2';
import { PDF_TEMPLATE_3 } from './components/PDF_TEMPLATE_3';
import { PDF_TEMPLATE_4 } from './components/PDF_TEMPLATE_4';
import { setBasicDefaultStyles } from './utils';

import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';

const { actions } = pdfSlice;

export function PdfPreviewScreen() {
  const dispatch = useAppDispatch();

  const qrCodeState = useSelector(getQrCodeReducerData);
  const pdfState = useSelector(getPdfReducer);
  const [forceRefresh, setForceRefresh] = useState(0);

  const [searchParams] = useSearchParams();
  const createdId = searchParams.get(QR_CODE_BUILDER_CREATED_ID_PARAM_NAME) || null;

  const {
    selectedTemplate,
    basicInformation: { isFileUpload, images },
    isCoverImageUploaded,
  } = useSelector(getPdfReducer);

  useEffect(() => {
    if ((!createdId && !isCoverImageUploaded) || (createdId && !isCoverImageUploaded && !pdfState.micrositeData)) {
      setForceRefresh((prevTrigger) => prevTrigger + 1);
    }

    if (!createdId) {
      setBasicDefaultStyles(selectedTemplate, dispatch, actions);

      (async function () {
        if (selectedTemplate === 0) {
          try {
            const coverImageFile = await getFileFromLocalSource(`${window.location.origin}${PDF_DEFAULT_0}`);
            const coverImageIdData = await filesAPIService.uploadImage(coverImageFile);

            dispatch(updatePdfThunk({ cover_image_id: coverImageIdData.data }));
          } catch (error) {
            logger.log(error);
          }
        } else if (selectedTemplate === 1 || selectedTemplate === 2) {
          dispatch(updatePdfThunk({ cover_image_id: null }));
        } else {
          try {
            const coverImageFile = await getFileFromLocalSource(`${window.location.origin}${DEFAULT_PDF_LOGO}`);
            const coverImageIdData = await filesAPIService.uploadImage(coverImageFile);

            dispatch(updatePdfThunk({ cover_image_id: coverImageIdData.data }));
          } catch (error) {
            logger.log(error);
          }
        }
      })();

      dispatch(updatePdfThunk({ selected_template: selectedTemplate }));
    }
  }, [selectedTemplate]);

  useEffect(() => {
    if (!pdfState.micrositeData && forceRefresh && !createdId) {
      modelMicrositeService.pdf(pdfState, qrCodeState, { dispatch, actions }, true);
    }

    if (createdId && !pdfState.micrositeData?.id && forceRefresh) {
      setBasicDefaultStyles(selectedTemplate, dispatch, actions);
      modelMicrositeService.pdf(pdfState, qrCodeState, { dispatch, actions }, true);
    }
  }, [forceRefresh]);

  if (isFileUpload) {
    return <PreviewFullPdfViewer link={images[0]?.previewPdfLink} />;
  }

  switch (selectedTemplate) {
    case 0:
      return <PDF_TEMPLATE_0 />;
    case 1:
      return <PDF_TEMPLATE_1 />;
    case 2:
      return <PDF_TEMPLATE_2 />;
    case 3:
      return <PDF_TEMPLATE_3 />;
    case 4:
      return <PDF_TEMPLATE_4 />;
    default:
      return null;
  }
}
